import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import { SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'delivery-info',
  templateUrl: './delivery-info.component.html',
  styleUrls: ['./delivery-info.component.less']
})
export class DeliveryInfoComponent implements OnInit, OnDestroy{

  addressLink: SafeHtml;
  shopAddress : SafeHtml;
  deliveryMailInfo : SafeHtml;
  worktime : SafeHtml;
  courierDeliveryInfo : SafeHtml;
  deliveryQuestions : SafeHtml;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService,
  ) {
    this.shopAddress = environment.shopAddress.address;
    this.addressLink = environment.shopAddress.link;
  }

  ngOnInit(): void {
  this.informationService.getFrontParams().pipe(
          takeUntil(this.destroySubject),
        )
          .subscribe(
            (res: any) => {
                  let deliveryMailInfoHtml = res.results.find ((value:any) =>  value.name == 'deliveryMailInfo')?.value;
                  this.deliveryMailInfo = this.informationService.getSanitizeString(deliveryMailInfoHtml);

                  let shopAddressHtml = res.results.find ((value:any) =>  value.name == 'address')?.value;
                  this.shopAddress = this.informationService.getSanitizeString(shopAddressHtml);

                  let worktimeHtml = res.results.find ((value:any) =>  value.name == 'worktime')?.value;
                  this.worktime = this.informationService.getSanitizeString(worktimeHtml);

                  let courierDeliveryInfoHtml = res.results.find ((value:any) =>  value.name == 'courierDeliveryInfo')?.value;
                  this.courierDeliveryInfo = this.informationService.getSanitizeString(courierDeliveryInfoHtml);

                  let deliveryQuestionsHtml = res.results.find ((value:any) =>  value.name == 'deliveryQuestions')?.value;
                  this.deliveryQuestions = this.informationService.getSanitizeString(deliveryQuestionsHtml);

            })
  }



  ngOnDestroy() {
    this.destroySubject.next();
  }

}




